import { isAnyOf } from '@reduxjs/toolkit';
import { AppStartListening } from '@/app/appMiddleware';
import { RootState } from '@/app/appStore';
import { appSession } from '@/shared/lib/storage';
import { login, logout } from './actions';

export function addAuthListener(startListening: AppStartListening) {
  startListening({
    matcher: isAnyOf(login.fulfilled, logout.fulfilled),
    effect: (_, listenerApi) => {
      const state = listenerApi.getState() as RootState;

      if (state.auth.user) {
        appSession.setItem(state.auth.user);
      } else {
        appSession.removeItem();
      }
    },
  });
}
